export * from '@core/js/components/main/NavigationBar/helpers';

export const getMenuSiblingsByUrl = (url) => (items) => {
    for (const item of items) {
        if (item.friendlyURL === url) {
            return items;
        }

        if (item.children) {
            const found = getMenuSiblingsByUrl(url)(item.children);

            if (found) {
                return item.children;
            }
        }
    }
};
